import { render, staticRenderFns } from "./stock_article.vue?vue&type=template&id=5bd050ea&scoped=true&"
import script from "./stock_article.vue?vue&type=script&lang=js&"
export * from "./stock_article.vue?vue&type=script&lang=js&"
import style0 from "./stock_article.vue?vue&type=style&index=0&id=5bd050ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd050ea",
  null
  
)

export default component.exports